function toggleCalendar(btn) {
  btn.nextElementSibling.classList.toggle('open');
}
function openShowcase(id) {
  document.getElementById('showcase-' + id).classList.add('open');
}
function closeShowcase(id) {
  document.getElementById('showcase-' + id).classList.remove('open');
}
function filterYear(year) {
  document.querySelectorAll('.trade-show-card').forEach(card => {
    card.style.display =
      year === 'all' || card.dataset.year === year ? 'block' : 'none';
  });
}
function openShowcase(id) {
  const modal = document.getElementById('showcase-' + id);
  if (!modal) return;

  modal.classList.add('open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeShowcase(id) {
  const modal = document.getElementById('showcase-' + id);
  if (!modal) return;

  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
